import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useCustomTranslation } from 'hooks/useCustomTranslation'
import { changeWebsiteTitle } from 'utils/changeWebsiteTitle'

export interface HeaderProps {
  isLoading: boolean
}

export const useHeader = (props: HeaderProps) => {
  const [scrolled, setScrolled] = useState(false)
  const [isMobileNavActive, setIsMobileNavActive] = useState(false)
  const [isLanguageDdlDisplayed, setIsLanguageDdlDisplayed] = useState(false)

  const location = useLocation()
  const { i18n, t } = useCustomTranslation()

  enum Languages {
    Ar = 'ar',
    En = 'en',
    De = 'de',
  }

  const isInnerPage =
    location.pathname !== `/${Languages.Ar}` &&
    location.pathname !== `/${Languages.En}` &&
    location.pathname !== `/${Languages.De}`

  const toggleMobileNav = (toggle?: boolean) => {
    if (typeof toggle === 'boolean') setIsMobileNavActive(toggle)
    else setIsMobileNavActive(!isMobileNavActive)
  }

  const toggleLanguageDdl = () => {
    if (window.innerWidth < 1200)
      setIsLanguageDdlDisplayed(!isLanguageDdlDisplayed)
  }

  const isHighlighted = (path: string) => {
    return location.pathname === path
  }

  const handleChangeLanguage = (newLanguage: 'en' | 'ar') => {
    const currentLanguage = i18n.language

    if (currentLanguage !== newLanguage) {
      changeWebsiteTitle(newLanguage === Languages.Ar)

      i18n.changeLanguage(newLanguage)
      document.documentElement.dir = newLanguage === 'ar' ? 'rtl' : 'ltr'
      document.documentElement.lang = newLanguage

      const oldPath = window.location.href
      const newPath = oldPath.replace(`/${currentLanguage}`, `/${newLanguage}`)

      history.pushState({}, '', newPath)
    }
  }

  useEffect(() => {
    if (window.scrollY > 0) {
      setScrolled(true)
    } else {
      setScrolled(false)
    }

    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true)
      } else {
        setScrolled(false)
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return {
    ...props,
    scrolled,
    isMobileNavActive,
    isLanguageDdlDisplayed,
    isInnerPage,
    t,
    isHighlighted,
    toggleMobileNav,
    toggleLanguageDdl,
    handleChangeLanguage,
  }
}
